import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  TextField,
  InputAdornment,
  IconButton,
  withTheme,
  Snackbar,
  SnackbarContent
} from "@material-ui/core";
import { VisibilityOff, Visibility } from "@material-ui/icons";
import cache from "../../framework/cache";
import { isEmail, isMobilePhone } from "validator";
import globalContext from "../../context/globalContext";
import MaskedInput from "react-text-mask";
import s from "./Register.module.css";
import label from "../../framework/whiteLabel";

const Register = props => {
  const context = useContext(globalContext);

  //FIELD DATA
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  //INPUT LABELS
  const [labelText, setLabelText] = useState("email");
  const [passwordLabel, setPasswordLabel] = useState("password");
  const [showPassword, toggleShowPassword] = useState(false);
  // eslint-disable-next-line
  const [toggleSubmitted, setToggleSubmitted] = useState(false);
  // eslint-disable-next-line
  const [toggleError, setToggleError] = useState(false);

  const [passwordError, setPasswordError] = useState(false);

  const [emailText, setEmailText] = useState("");
  const [emailError, setEmailError] = useState(false);

  const [snackBarOpenState, setSnackBarState] = useState(false);
  // eslint-disable-next-line
  const [apiErrorMessage, setApiErrorMessage] = useState("");
  const [phoneError, togglePhoneError] = useState(false);

  const clearError = () => {
    setToggleError(false);
    setSnackBarState(false);
    setLabelText("email");
    setEmailError(false);
  };

  let content = (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
        open={snackBarOpenState}
        autoHideDuration={6000}
      >
        <SnackbarContent
          style={{ background: "red", color: "white", textAlign: "center" }}
          onClose={() => clearError()}
          variant="error"
          message={<>{apiErrorMessage}</>}
          onClick={() => setSnackBarState(false)}
        />
      </Snackbar>
      <div className={s.root}>
        <div className={s.rootInner}>
        <img src={label.logoUrl} alt="" className={s.logo} />
        <h1 className={s.heading_label}>{label.title}</h1>
          {/* <section className={s.taglineSection}>
            <h1 className={s.heading}>$5.00 Off</h1>
            <h2 className={s.subHeading}>Your First Order!</h2>
          </section> */}
          <section className={s.signInSection}>
            <p>Already have an account?</p>
            <Link to="/login" className={s.signInLink}>
              Sign in!
            </Link>
          </section>
          <div className={s.form}>
            <TextField
              name={"firstName"}
              placeholder={"first name"}
              value={firstName}
              error={false}
              label={"first name"}
              onChange={event => {
                setFirstName(event.target.value);
                clearError();
              }}
              autoCapitalize="none"
              autoCorrect="none"
              margin="normal"
            />
            <TextField
              name={"lastName"}
              placeholder={"last name"}
              value={lastName}
              error={false}
              label={"last name"}
              onChange={event => {
                setLastName(event.target.value);
                clearError();
              }}
              autoCapitalize="none"
              autoCorrect="none"
              margin="dense"
            />
            <TextField
              name={"phone"}
              placeholder={"phone #"}
              value={phone}
              type={"tel"}
              error={phoneError}
              label={phoneError ? "Must be valid phone #" : "phone"}
              onChange={event => {
                setPhone(event.target.value);
                clearError();
                togglePhoneError(false);
              }}
              autoCapitalize="none"
              autoCorrect="none"
              margin="dense"
              InputProps={{
                inputComponent: TextMaskCustom,
                type: "tel"
              }}
            />
            <TextField
              name={"email"}
              placeholder={"email"}
              value={email}
              error={emailError}
              label={labelText}
              onChange={event => {
                setEmail(event.target.value);
                clearError();
              }}
              autoCapitalize="none"
              autoCorrect="none"
              margin="dense"
              helperText={emailError ? emailText : ""}
            />
            <TextField
              name={"password"}
              placeholder={"password"}
              value={password}
              error={passwordError}
              type={showPassword ? "text" : "password"}
              label={"password"}
              onChange={event => {
                setPassword(event.target.value);
                clearError();
              }}
              autoCapitalize="none"
              autoCorrect="none"
              helperText={passwordError ? passwordLabel : ""}
              margin="dense"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => toggleShowPassword(!showPassword)}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <Button
              onClick={async () => {
                const cleanedPhoneNumber = phone.replace(/\D+/g, "");
                if (password.length < 3) {
                  setPasswordLabel("Password is too short!");
                  setPasswordError(true);
                  return;
                }

                if (
                  isEmail(email) &&
                  isMobilePhone(cleanedPhoneNumber, "en-US")
                ) {
                  context.global
                    .apiPost({
                      path: "/register",
                      body: {
                        firstName,
                        lastName,
                        phone: cleanedPhoneNumber,
                        email: email.toLowerCase(),
                        password
                      },
                      auth: false
                    })
                    .then(response => {
                      cache.clearAll();
                      cache.setItem("USER_TOKEN", response.token.token);
                      cache.setItem(
                        "USER_REFRESH_TOKEN",
                        response.token.refreshToken
                      );
                      cache.setItem("USER_UUID", response.user.uuid);
                    })
                    .then(() => {
                      props.history.replace(`/find-hot-spot`);
                    })

                    .catch(err => {
                      setToggleError(true);
                      setToggleSubmitted(true);
                      setLabelText("Must be valid email");
                      setEmailError(true);
                    });
                }

                if (!isEmail(email)) {
                  setEmailText("Must be valid email");
                  setEmailError(true);
                  return;
                }

                if (!isMobilePhone(phone, "en-US")) {
                  togglePhoneError(true);
                }
              }}
              style={{ marginBlockStart: 32, marginBlockEnd: 32 }}
            >
              Register
            </Button>
          </div>
          <section className={s.legalSection}>
            <Link to="/privacy-policy" className={s.link}>
              Privacy Policy
            </Link>
            <span className={s.link}>|</span>
            <Link to="/terms-of-service" className={s.link}>
              Terms of Service
            </Link>
          </section>
        </div>
      </div>
    </>
  );

  return content;
};

export default withTheme()(Register);

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      keepCharPositions={true}
      mask={[
        "(",
        /[1-9]/,
        /\d/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      placeholderChar={"\u2000"}
      // showMask
    />
  );
}
